import { all as allAirports } from 'pages/airports'

export default [
  { path: '/airports', name: 'airports.all', component: allAirports
    , meta:{permits:['location_user', 'location_list']}},
]
